import { z } from 'zod'

const jsonResponse = z.object({}).passthrough()
export const learningHealthResponseSchema = jsonResponse
export const learningRuntimeInfoResponseSchema = jsonResponse
export const learningLmengineIngestResponseSchema = jsonResponse
export const learningThinkificAssignmentImportResponseSchema = jsonResponse
export const learningThinkificEnrollmentSyncResponseSchema = jsonResponse
export const learningVjalMemberImportResponseSchema = jsonResponse
export const learningVjalMembershipImportResponseSchema = jsonResponse
export const learningVjalGrantImportResponseSchema = jsonResponse
export type LearningHealthResponse = z.infer<typeof learningHealthResponseSchema>
export type LearningRuntimeInfoResponse = z.infer<typeof learningRuntimeInfoResponseSchema>
export type LearningLmengineIngestResponse = z.infer<typeof learningLmengineIngestResponseSchema>
export type LearningThinkificAssignmentImportResponse = z.infer<typeof learningThinkificAssignmentImportResponseSchema>
export type LearningThinkificEnrollmentSyncResponse = z.infer<typeof learningThinkificEnrollmentSyncResponseSchema>
export type LearningVjalMemberImportResponse = z.infer<typeof learningVjalMemberImportResponseSchema>
export type LearningVjalMembershipImportResponse = z.infer<typeof learningVjalMembershipImportResponseSchema>
export type LearningVjalGrantImportResponse = z.infer<typeof learningVjalGrantImportResponseSchema>
